document.addEventListener('DOMContentLoaded', () => {
  // Debounce function to limit how often a function can fire
  function debounce(func, delay) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // Sticky sidebar subnav
  const header = document.getElementById('sticky-nav');

  // Add or remove "sticky" class based on scroll position
  if (header) {
    window.addEventListener('scroll', debounce(() => {
      if (window.scrollY > 100) {
        // Change 20 to the desired offset
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }, 20)); // Adjust the debounce time as needed
  }

  /* Target paths for Houthi reports
    - adds class "houthis" to body tag
    - adds wrapper div to content
    - generates link to quicklinks
    - generates links to related reports

    Editable:
    targetPath1 = /content/houthis-and-us-designated-foreign-terrorist-organizations
    .link-part1 = "The Houthis and U.S.-Designated Foreign Terrorist Organizations"
    '.link-item1', '.link-item2', '.link-item3', '.link-item4' = "Executive Summary", "Hamas", "Hezbollah", "Conclusions & Recommendations"
  */

  // Get the current page's path
  const currentPath = window.location.pathname;

  // Array of path to reports - also order of the related reports
  // Array 1-6 is for Houthi report
  // Array 7 is for Opaque Operation report and DOES NOT go into Houthi report
  // Array 9 is part of Houthi report
  const targetPaths = [
    "/content/houthis-and-us-designated-foreign-terrorist-organizations",
    "/content/houthis-use-technology-repression",
    "/content/how-houthis-built-their-arsenal-defense-and-intelligence-procurement",
    "/content/houthi-targeting-religious-minorities",
    "/content/houthis-terrorizing-women-and-journalists",
    "/content/houthi-diversion-humanitarian-assistance-yemen",
    "/content/opaque-operations-transparency-gap-humanitarian-work-somalia",
    "/content/eyes-regime-how-houthi-security-and-intelligence-service-ensures-political-domination-yemen"
  ];

  if (targetPaths.includes(currentPath)) {
    document.body.classList.add('report-with-sticky-sidebar');

    const fieldBodyClass = document.querySelector(".field--name-body");
    if (fieldBodyClass) {
      fieldBodyClass.innerHTML = "<div class='o-report--wrapper' id='top'>" + fieldBodyClass.innerHTML + "</div>";
    }

    // Array of report for "Related Report"
    // Array 1-6 is for Houthi report
    // Array 7 is for Opaque Operation report and does not go into Houthi report
    const linkParts = ['.link-part1', '.link-part2', '.link-part3', '.link-part4', '.link-part5', '.link-part6', '.link-part8'];
    const linkTexts = [
      "The Houthis and U.S.-Designated Foreign Terrorist Organizations",
      "The Houthis’ Use of Technology for Repression",
      "How the Houthis Built Their Arsenal: Defense and Intelligence Procurement",
      "Houthi Targeting of Religious Minorities",
      "The Houthis: Terrorizing Women and Journalists",
      "Houthi Diversion of Humanitarian Assistance in Yemen",
      "Eyes of the Regime: How the Houthi Security and Intelligence Service Ensures Political Domination in Yemen"
    ];

    // Add link and text to "Related Reports"
    linkParts.forEach((part, index) => {
      const linkPart = document.querySelector(part);
      if (linkPart) {
        linkPart.innerHTML += `<a href='${targetPaths[index]}'>${linkTexts[index]}</a>`;
      }
    });

    // Array for "Quick Links"
    const linkItems = ['.link-item1', '.link-item2', '.link-item3', '.link-item4', '.link-item5', '.link-item6', '.link-item7'];
    const linkTextsMap = {
      targetPath1: ["Executive Summary", "Hamas", "Hezbollah", "Conclusions & Recommendations"],
      targetPath2: ["Introduction", "The Houthis and MNOs: A Valuable Source of Revenue and Intelligence", "Internet in Yemen: Houthis Control and Exploitation", "Conclusion"],
      targetPath3: ["Introduction", "Military and Diplomatic Context", "Conclusion", "Annex A"],
      targetPath4: ["Introduction", "Persecution of Baha’is", "Persecution of Jews", "Conclusion"],
      targetPath5: ["Introduction", "Section 1: Women Targeted by the Houthi Regime", "Section 2: Journalists Targeted by the Houthi Regime", "Conclusion"],
      targetPath6: ["Executive Summary", "Assistance Overview: The Yemeni Context (Background)", "Assistance Overview: The Yemeni Context (Houthi Interference in Humanitarian Aid)", "Data Collection, Aid Distribution, and Minimal Transparency", "Conclusion and Recommendations"],
      targetPath7: ["Executive Summary", "Background on Humanitarian Aid In Somalia", "The Weaknesses and Failures of UN INGO Oversignt", "Gatekeepers, Corrupt Officials, and Terrorists", "Conclusions & Recommendations"],
      targetPath8: ["Foreword", "Executive Summary", "Introduction", "National Leadership", "Governorate-Level Leadership", "SIS Evolution: Maintaining Control Over Humanitarian Aid", "Conclusion"]
    };

    // Add link and text to "Quick Links"
    linkItems.forEach((item, index) => {
      const linkElements = document.querySelectorAll(item);
      if (linkElements.length > 0) {
        // Get the text to add from the linkTextsMap based on the current path
        const linkText = linkTextsMap[`targetPath${targetPaths.indexOf(currentPath) + 1}`][index];
        // Iterate over each element and add the text
        linkElements.forEach(element => {
          element.innerHTML += linkText;
        });
      }
    });
  }

  // Loop through the elements and add a unique numbered class to "Quick Links"
  document.querySelectorAll(".m-report--highlight").forEach((element, index) => {
    element.classList.add("m-report--highlight-" + (index + 1));
  });

  // Focus state dots for "Quick Links"
  // Get all the anchor elements within the list
  const anchorLinks = document.querySelectorAll('#nav li a');

  // Attach click event listeners to each anchor element
  anchorLinks.forEach(anchor => {
    anchor.addEventListener('click', function(event) {
      // Remove the "active" class from all li elements
      document.querySelectorAll('#nav li').forEach(li => {
        li.classList.remove('active');
      });

      // Add the "active" class to the parent li element
      this.parentElement.classList.add('active');

      // Scroll to the target section
      const targetId = this.getAttribute('href');
      const targetSection = document.querySelector(targetId);
      if (targetSection) {
        event.preventDefault(); // Prevent the default scroll behavior
        targetSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}); // End DOM
